export * from './lib/pipes-get-pnr.module';
